/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content, no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import C from '../constants';

export class PlaceHolderImage extends React.PureComponent {
  onAddImage = (event) => {
    const imageType = event.target.dataset.imagetype;

    this.props.onAddImage(imageType);
  }

  render() {
    const typeInfo = C.aspectRatios[this.props.type];

    const height = 80;
    const width = typeInfo.aspectRatio * height;
    const emptyStyle = {
      width: `${width}px`,
      height: `${height}px`,
      borderColor: '#D90026',
    };

    return (
      <div
        className="image-list-item empty-image-list-item"
        key={this.props.type}
      >
        <button
          style={emptyStyle}
          onClick={this.onAddImage}
          data-imagetype={this.props.type}
        >
          {this.props.i18n.getString('ImageEditor_AddImage')}
        </button>
        <div className="image-item-ratio-label" style={{ color: '#D90026' }}>
          {this.props.i18n.getString(C.aspectRatios[this.props.type].stringKey)}
        </div>
      </div>
    );
  }
}

PlaceHolderImage.propTypes = {
  type: PropTypes.string.isRequired,
  onAddImage: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
};
